"use client";

import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFirebaseContext } from '../lib/context/Firebase';
import { useAppSelector } from '../lib/hooks';
import { useAuthState } from 'react-firebase-hooks/auth';
import { User } from 'firebase/auth';

export default function Home() {
    const firebase = useFirebaseContext();
    const selectedBuilding = useAppSelector(state => state.building.building)
    const user = useAppSelector(state => state.user)
    const authenticatedUser = useAppSelector(state => state.user.user)
    const navigate = useNavigate();

    const redirectToSignup = useCallback(() => {
        if (selectedBuilding !== undefined) {
            navigate("/signup")
        }
    }, [navigate, selectedBuilding])

    useAuthState(firebase.auth, {
        onUserChanged: async (user: User | null) => {
            if (user !== null) {
                redirectToSignup();
            }
        }
    })

    useEffect(() => {
        if (user !== null) {
            redirectToSignup();
        }
    }, [user, redirectToSignup]);

    // Home has no landing page of its own, so a null Redux user must always go through /login --
    // even without a cached MSAL account. That cache lives in sessionStorage and is gone after the
    // tab closes, while the Firebase session survives; gating on `accounts` left such returning
    // users stuck on "Logging you in..." forever.
    useEffect(() => {
        if (authenticatedUser == null) {
            navigate("/login?next=/")
        }
    }, [authenticatedUser, navigate]);

    return (
        <div>Logging you in...</div>
    )

}
